import React from 'react';

export function FullLoader({ message = 'Processing…' }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 999,
      background: 'rgba(26,35,64,0.55)', backdropFilter: 'blur(3px)',
      display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: 16,
    }}>
      <div style={{ position: 'relative', width: 56, height: 56 }}>
        {/* Spinning ring */}
        <svg width="56" height="56" viewBox="0 0 56 56" style={{ position: 'absolute', inset: 0, animation: 'spin 1s linear infinite' }}>
          <style>{'@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }'}</style>
          <circle cx="28" cy="28" r="22" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="4"/>
          <circle cx="28" cy="28" r="22" fill="none" stroke="#8B1A2E" strokeWidth="4"
            strokeDasharray="138" strokeDashoffset="100" strokeLinecap="round"/>
        </svg>
        {/* Envelope center */}
        <div style={{
          position: 'absolute', inset: 0, display: 'flex',
          alignItems: 'center', justifyContent: 'center',
          fontSize: 20, animation: 'pulse-env 1s ease-in-out infinite alternate',
        }}>
          <style>{'@keyframes pulse-env { from { transform: scale(0.85); } to { transform: scale(1.1); } }'}</style>
          ✉
        </div>
      </div>
      <div style={{ color: '#fff', fontSize: 14, fontWeight: 600, fontFamily: 'system-ui,sans-serif' }}>{message}</div>
    </div>
  );
}

export function InlineLoader({ message = 'Loading…' }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '16px 0', color: 'var(--text3)', fontSize: 13 }}>
      <svg width="20" height="20" viewBox="0 0 20 20" style={{ animation: 'spin 1s linear infinite', flexShrink: 0 }}>
        <circle cx="10" cy="10" r="8" fill="none" stroke="var(--border2)" strokeWidth="2.5"/>
        <circle cx="10" cy="10" r="8" fill="none" stroke="#8B1A2E" strokeWidth="2.5"
          strokeDasharray="50" strokeDashoffset="35" strokeLinecap="round"/>
      </svg>
      {message}
    </div>
  );
}
